import type * as getToggleState from "./getToggleState";
import { LazyAction, LazyModule } from "owa-bundling-light";

// The toggle may be accessed on boot, to minimize the boot bundle size we will
// lazy load the code for actually getting the toggle state
const lazyModule: LazyModule<typeof getToggleState> = new LazyModule<typeof getToggleState>(() => import(/* webpackChunkName: "GetToggleState" */ "./getToggleState"), { name: "GetToggleState" });

export const lazyGetToggleState: LazyAction<typeof getToggleState.getToggleState, typeof lazyModule> = new LazyAction(lazyModule, m => m.getToggleState);
